export default "public/logo-cs.png";